module.exports = __webpack_public_path__ + "media/stockholm/side_ship-d7e0a2ce.jpg";